import {
	userinfoData,
	goodsRelativeInfoData,
	goodsConfigData,
	submitRelative,
	similarGoodsData,
	syncProduct,
	alibabaRelativeInfoData,
	alibabaSkuInfoData,
	orderManageList,
	orderManageAddressInfo,
	orderManageShopList,
	editSyncOrderQueue,
	orderManageDetail,
	orderManageFilterData,
	orderManageBatPurchase,
	orderManageBatAbnormal,
	orderManageBatchMarkAbnormal,
	orderManageChangeSku,
	orderManageRemarkInfo,
	orderManageAddRemark,
	orderManageServiceRemarkInfo,
	orderManageAddServiceRemark,
	orderManageReceipt,
	ddShopRefreshDecrypt,

	unDecrypt,
	reDecrypt,
	decrypt,
	baseConfig,
	checkPrintRecharge,

	editPrintProduct,
	setPddReturnAddress,
	pddAccountList,
	pddAccountAdd,
	pddAccountDel,
	pddAccountUpdate,
	pddAccountDefault,
	pddAccountSyncOrder,
	mallCateList,

	orderManageDeleteProduct,
	orderManageDelPddOrder,
	orderManageRepealPurchase,
	orderManageNeedSyncPddOrder,
	orderManageUpdateOrderAfterSale,
	orderManageCancelDelete,
	refreshReturnAddress,
	updatePddAccount,
	updateOrderProduct,
	setSellerWords,
	updatePddOrderNo,
	syncDdProductInfo,
	submitPddSkuRelative,
	submitAlibabaSkuRelative,
	orderGetPddSkuInfo,
	updateBuyMode,
	orderManageSendGiftOrder,
	orderManageSetNotDealOrder,
	setAutoSendGift,
	setAutoRefundReason,
	getStatisticData,
	getStatisticExpressData,
	getStatisticRanking,
	getStatisticProductDetailData,
	getStatisticShopProductRanking,
	getStatisticProductList,
	orderManageCheckAliOrderType,
	checkIsOpenProtocolPay,
	opDoOrderPay,

	regionData,
	ddReturnAddressInfo,
	editDdReturnAddress,
	afterSalesfilterData,
	orderAfterSalesList,
	businessAddressInfo,
	editBusinessAddress,
	searchAlibabaProductByImage,
	strategyDeleteSet,
	editStrategyDeleteSet,
	explainAddress,
	businessSetSyncReturnAddressType,
	addSyncDdOrderQueue,
	ddAftersaleBatchOperate,
	ddAftersaleDetail,
	ddAftersaleOperate,
	ddAftersaleTimeExtend,
	ddAftersaleApplyLogisticsIntercept,
	ddReturnAddressList,
	orderServerGetOperateInfo,
	ddAftersaleAddRemark,
	uploadBasinessUpload,
	getAlibabaProductFilterTypeList,
	alibabaSkuRelativeHistory,
	businessSetAftersaleConfig,
	orderManageMarkProblem,
	orderManageDdLogisticsCompanies,
	orderManageEditDdDeliverLogistics,
	orderManageManualDdDeliver,
	orderManageBatchMarkException,
	orderManageFetchAlibabaSendTime,
	querySkuRelativeInfo
} from "../../../api/main/ucenter_order.js";
let modules = {
	namespaced: true,
	state: {


	},
	mutations: {

	},
	actions: {
		getUserinfoData(conText, payload){//获取个人信息
			userinfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},

		/**
		 * 关联商品
		 */
		GetGoodsRelativeInfoData(conText, payload){//获取关联商品信息
			goodsRelativeInfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetAlibabaRelativeInfoData(conText, payload){//获取关联1688商品信息
			alibabaRelativeInfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetAlibabaSkuInfoData(conText, payload){//获取1688商品sku
			alibabaSkuInfoData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetAlibabaSkuRelativeHistory(conText, payload){//历史关联1688商品规格记录
			alibabaSkuRelativeHistory(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetGoodsConfigData(conText, payload){//获取关联商品信息
			goodsConfigData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSubmitRelative(conText, payload){//关联商品信息
			submitRelative(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		GetQuerySkuRelativeInfo(conText, payload){//查询规格永久关联信息
			querySkuRelativeInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		},
		getSimilarGoodsData(conText, payload){//搜索同款商品
			similarGoodsData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSyncProduct(conText, payload){//一键同步商品
			syncProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getOrderManageAddressInfo(conText, payload){//查看收货人信息
			orderManageAddressInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},

		getOrderManageList(conText, payload){//订单列表
			orderManageList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getOrderManageShopList(conText, payload){//查看所有店铺
			orderManageShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		postEditSyncOrderQueue(conText, payload){//编辑提交同步历史订单
			editSyncOrderQueue(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageDetail(conText, payload){//订单详情
			orderManageDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageFilterData(conText, payload){//订单筛选数据
			orderManageFilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatPurchase(conText, payload){//手动批量采购
			orderManageBatPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageCheckAliOrderType(conText, payload){//手动批量采购
			orderManageCheckAliOrderType(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatAbnormal(conText, payload){//批量标记异常
			orderManageBatAbnormal(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatchMarkAbnormal(conText, payload){//批量标记/取消异常单
			orderManageBatchMarkAbnormal(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageBatchMarkException(conText, payload){//批量标记/取消异常订单
			orderManageBatchMarkException(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
				if (payload.fail) {
					payload.fail(res)
				}
			}).catch(() => {
				if (payload.fail) {
					payload.fail()
				}
			})
		},
		opOrderManageMarkProblem(conText, payload){//标记问题订单
			orderManageMarkProblem(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
				if (payload.fail) {
					payload.fail(res)
				}
			}).catch(() => {
				if (payload.fail) {
					payload.fail()
				}
			})
		},
		doOrderManageChangeSku(conText, payload){//关联商品
			orderManageChangeSku(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageRemarkInfo(conText, payload){//订单标记备注信息
			orderManageRemarkInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageAddRemark(conText, payload){//添加备注和旗子
			orderManageAddRemark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getOrderManageServiceRemarkInfo(conText, payload){//订单客服备注信息
			orderManageServiceRemarkInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageDeleteProduct(conText, payload){//添加客服备注
			orderManageDeleteProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageAddServiceRemark(conText, payload){//添加客服备注
			orderManageAddServiceRemark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opRefreshReturnAddress(conText, payload){
			refreshReturnAddress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageReceipt(conText, payload){//确认收货
			orderManageReceipt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageSendGiftOrder(conText, payload){//发送礼品单
			orderManageSendGiftOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageSetNotDealOrder(conText, payload){//设置完结订单
			orderManageSetNotDealOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageDelPddOrder(conText, payload){//删除订单
			orderManageDelPddOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageCancelDelete(conText, payload){//删除订单
			orderManageCancelDelete(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageRepealPurchase(conText, payload){//重新采购
			orderManageRepealPurchase(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageNeedSyncPddOrder(conText, payload){//同步PDD订单
			orderManageNeedSyncPddOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageUpdateOrderAfterSale(conText, payload){//同步抖店
			orderManageUpdateOrderAfterSale(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDdShopRefreshDecrypt(conText, payload){//提额成功更新店铺状态
			ddShopRefreshDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUnDecrypt(conText, payload){//放弃解密
			unDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opReDecrypt(conText, payload){//恢复解密
			reDecrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDecrypt(conText, payload){//解密单个订单
			decrypt(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getBaseConfig(conText, payload){//基础设置
			baseConfig(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getCheckPrintRecharge(conText, payload){//查询充值打单情况
			checkPrintRecharge(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opEditPrintProduct(conText, payload){//编辑打单商品配置
			editPrintProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetPddReturnAddress(conText, payload){//修改退货地址
			setPddReturnAddress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetSellerWords(conText, payload){
			setSellerWords(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdatePddAccount(conText, payload){
			updatePddAccount(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdatePddOrderNo(conText, payload){
			updatePddOrderNo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdateOrderProduct(conText, payload){
			updateOrderProduct(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opUpdateBuyMode(conText, payload){
			updateBuyMode(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountList(conText, payload){//获取多多账号列表
			pddAccountList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opCheckIsOpenProtocolPay(conText, payload){//查询是否开通免密支付
			checkIsOpenProtocolPay(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountAdd(conText, payload){//新增多多账号
			pddAccountAdd(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountDel(conText, payload){//删除多多账号
			pddAccountDel(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountUpdate(conText, payload){//更新多多账号
			pddAccountUpdate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountDefault(conText, payload){//设置多多默认账号
			pddAccountDefault(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opPddAccountSyncOrder(conText, payload){
			pddAccountSyncOrder(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opMallCateList(conText, payload){
			mallCateList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSyncDdProductInfo(conText, payload){
			syncDdProductInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSubmitPddSkuRelative(conText, payload){
			submitPddSkuRelative(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSubmitAlibabaSkuRelative(conText, payload){
			submitAlibabaSkuRelative(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doOrderGetPddSkuInfo(conText, payload){
			orderGetPddSkuInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetAutoSendGift(conText, payload){//检查扫码支付状态
			setAutoSendGift(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opSetAutoRefundReason(conText, payload){//更新商家自动退款原因配置
			setAutoRefundReason(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDoOrderPay(conText, payload){//采购订单支付
			opDoOrderPay(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticData(conText, payload){
			getStatisticData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticRanking(conText, payload){
			getStatisticRanking(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticExpressData(conText, payload){
			getStatisticExpressData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticProductDetailData(conText, payload){
			getStatisticProductDetailData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticShopProductRanking(conText, payload){
			getStatisticShopProductRanking(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opGetStatisticProductList(conText, payload){
			getStatisticProductList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getRegionData(conText, payload){//获取省市区列表
			regionData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getDdReturnAddressInfo(conText, payload){//抖店商品退货地址
			ddReturnAddressInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opEditDdReturnAddress(conText, payload){//编辑抖店商品退货地址
			editDdReturnAddress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		doSearchAlibabaProductByImage(conText, payload){//图搜阿里巴巴商品
			searchAlibabaProductByImage(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getStrategyDeleteSet(conText, payload){//获取策略删除设置
			strategyDeleteSet(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opEditStrategyDeleteSet(conText, payload){//编辑策略删除设置
			editStrategyDeleteSet(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getExplainAddress(conText, payload){//识别地址
			explainAddress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opBusinessSetSyncReturnAddressType(conText, payload){//设置同步退货地址时机
			businessSetSyncReturnAddressType(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opAddSyncDdOrderQueue(conText, payload){//添加同步抖店订单队列
			addSyncDdOrderQueue(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getAlibabaProductFilterTypeList(conText, payload){//获取1688精选货源商品筛选类型列表
			getAlibabaProductFilterTypeList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opOrderManageFetchAlibabaSendTime(conText, payload){
			orderManageFetchAlibabaSendTime(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.fail) {
					payload.fail()
				}
			})
		},
		opOrderManageDdLogisticsCompanies(conText, payload){//抖店快递公司列表
			orderManageDdLogisticsCompanies(payload.data || {}).then(res => {
				if (payload.success) {
					payload.success(res)
				}
				if (payload.fail) {
					payload.fail(res)
				}
			}).catch(() => {
				if (payload.fail) {
					payload.fail()
				}
			})
		},
		opOrderManageEditDdDeliverLogistics(conText, payload){//修改运单
			orderManageEditDdDeliverLogistics(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
				if (payload.fail) {
					payload.fail(res)
				}
			}).catch(() => {
				if (payload.fail) {
					payload.fail()
				}
			})
		},
		opOrderManageManualDdDeliver(conText, payload){//手动发货
			orderManageManualDdDeliver(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
				if (payload.fail) {
					payload.fail(res)
				}
			}).catch(() => {
				if (payload.fail) {
					payload.fail()
				}
			})
		},

		/**
		 * 售后管理
		 */
		getAfterSalesfilterData(conText, payload){ //售后管理筛选条件
			afterSalesfilterData(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getOrderAfterSalesList(conText, payload){ //售后管理列表
			orderAfterSalesList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opDdAftersaleBatchOperate(conText, payload){
			ddAftersaleBatchOperate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getDdAftersaleDetail(conText, payload){
			ddAftersaleDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opDdAftersaleOperate(conText, payload){
			ddAftersaleOperate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opDdAftersaleTimeExtend(conText, payload){
			ddAftersaleTimeExtend(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opDdAftersaleApplyLogisticsIntercept(conText, payload){
			ddAftersaleApplyLogisticsIntercept(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getDdReturnAddressList(conText, payload){
			ddReturnAddressList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		getOrderServerGetOperateInfo(conText, payload){
			orderServerGetOperateInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opDdAftersaleAddRemark(conText, payload){
			ddAftersaleAddRemark(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opUploadBasinessUpload(conText, payload){
			uploadBasinessUpload(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opBusinessSetAftersaleConfig(conText, payload){//商家售后配置
			businessSetAftersaleConfig(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},

		/**
		 * 售后地址
		 */
		getBusinessAddressInfo(conText, payload){//商家地址
			businessAddressInfo(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
		opEditBusinessAddress(conText, payload){//编辑商家地址
			editBusinessAddress(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
			.catch(() => {
				if (payload.success) {
					payload.success({ code: 0, msg: '网络异常，请稍后重试' })
				}
			})
		},
	}
}
export default modules;
